import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermissoes } from "@/features/auth";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

/**
 * Shell do sistema interno: cabeçalho fixo, sidebar e área de conteúdo. Com `semConteudo` (sessão
 * ainda sendo conferida ao abrir), o shell aparece de verdade e a área de conteúdo fica vazia até
 * a tela entrar com o skeleton dela.
 */
export function AppLayout({ semConteudo = false }: { semConteudo?: boolean }) {
  const { pathname } = useLocation();
  const { papel, podeVerRota } = usePermissoes();
  // Tela fora do papel (ex.: Comercial de parceiros abrindo /reservas por um link): vai para o Estoque.
  if (papel && !podeVerRota(pathname)) return <Navigate to="/estoque" replace />;
  return (
    <div className="relative z-10 flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1">
        <Sidebar />
        <main className="min-w-0 flex-1">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-10">
            {!semConteudo && <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
}
